(function () {
  // -------------------------------------------------------------------
  // Main image swiper — no thumbnails in this template
  // -------------------------------------------------------------------
  var mainSwiperEl = document.querySelector(".image-main");
  if (!mainSwiperEl) return;

  var mainSwiper = new Swiper(".image-main", {
    loop: true,
    slidesPerView: 1.1,
    spaceBetween: 10,
    // Same reason as the default template: without this, Swiper reads the few pixels of drift a trackpad
    // press carries as a drag and cancels the click, leaving the video's own controls dead.
    noSwipingSelector: "video",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 8,
    },
    breakpoints: {
      568: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });

  // -------------------------------------------------------------------
  // Video autoplay: same fix as the default template's gallery — a video
  // slide relied entirely on native controls being clicked, and on some
  // Chrome/macOS setups those controls never render (or never receive the
  // click). Play the active slide's video directly once it becomes active.
  // -------------------------------------------------------------------
  function forcePlayGalleryVideo(video) {
    if (!video) return;
    // The video has no guaranteed buffered data until play() is called —
    // that call is what triggers the fetch, so it must fire unconditionally
    // here rather than waiting on a readiness event that may never come.
    video.muted = true;
    video.setAttribute("muted", "");
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {
        setTimeout(function () {
          video.muted = true;
          video.setAttribute("muted", "");
          video.play().catch(function () {});
        }, 200);
      });
    }
  }

  function playActiveGalleryVideo(swiperInstance) {
    var slides = swiperInstance && swiperInstance.slides;
    if (!slides || !slides.length) return;
    var activeSlide = slides[swiperInstance.activeIndex];
    Array.prototype.forEach.call(slides, function (slide) {
      var video = slide.querySelector("video");
      if (!video) return;
      if (slide === activeSlide) {
        forcePlayGalleryVideo(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  mainSwiper.on("slideChangeTransitionEnd", function () {
    playActiveGalleryVideo(mainSwiper);
  });
  setTimeout(function () {
    playActiveGalleryVideo(mainSwiper);
  }, 0);

  // Safari/iOS can still reject the very first play() call before any user
  // gesture has happened on the page at all; retry once on the first tap/click.
  document.addEventListener(
    "click",
    function () {
      playActiveGalleryVideo(mainSwiper);
    },
    { once: true }
  );
  document.addEventListener(
    "touchstart",
    function () {
      playActiveGalleryVideo(mainSwiper);
    },
    { once: true }
  );

  // -------------------------------------------------------------------
  // Variant → slide navigation
  // -------------------------------------------------------------------

  // Parse variants from the product JSON block rendered by product-form.liquid
  function getVariants() {
    var el = document.querySelector("[data-product-json]");
    if (!el) return [];
    try {
      return JSON.parse(el.innerHTML).product.variants || [];
    } catch (e) {
      return [];
    }
  }

  // Given a variant, return the image ID we should navigate to.
  // Shopify serializes it as featured_image (legacy) or featured_media (newer).
  function getVariantImageId(variant) {
    if (variant.featured_media && variant.featured_media.id) {
      return variant.featured_media.id;
    }
    if (variant.featured_image && variant.featured_image.id) {
      return variant.featured_image.id;
    }
    return null;
  }

  // Navigate the main swiper to the slide whose data-media-id matches imageId
  function goToVariantSlide(variant) {
    var imageId = getVariantImageId(variant);
    if (!imageId) return;

    var realSlides = mainSwiperEl.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    );

    var targetIndex = -1;
    realSlides.forEach(function (slide, index) {
      if (parseInt(slide.getAttribute("data-media-id"), 10) === imageId) {
        targetIndex = index;
      }
    });

    if (targetIndex !== -1) {
      mainSwiper.slideToLoop(targetIndex, 400);
    }
  }

  // Read all currently checked option radios and find the matching variant
  function getActiveVariant(variants) {
    var selected = {};
    document.querySelectorAll("[data-option-position][type='radio']:checked").forEach(function (radio) {
      selected[radio.getAttribute("data-option-position")] = radio.value;
    });

    return variants.find(function (v) {
      if (selected["1"] !== undefined && v.option1 !== selected["1"]) return false;
      if (selected["2"] !== undefined && v.option2 !== selected["2"]) return false;
      if (selected["3"] !== undefined && v.option3 !== selected["3"]) return false;
      return true;
    }) || null;
  }

  // -------------------------------------------------------------------
  // Init
  // -------------------------------------------------------------------
  var variants = getVariants();

  // 1. If URL has ?variant=ID, jump to that slide on load
  var urlVariantId = new URLSearchParams(window.location.search).get("variant");
  if (urlVariantId) {
    var urlVariant = variants.find(function (v) {
      return v.id.toString() === urlVariantId;
    });
    if (urlVariant) {
      setTimeout(function () { goToVariantSlide(urlVariant); }, 500);
    }
  }

  // 2. When any option radio changes, navigate to the new variant's slide.
  //    We attach to the document to catch radios rendered inside app blocks too.
  document.addEventListener("change", function (e) {
    var radio = e.target;
    if (
      radio.type !== "radio" ||
      !radio.getAttribute("data-option-position")
    ) return;

    var active = getActiveVariant(variants);
    if (active) goToVariantSlide(active);
  });
})();

// ---------------------------------------------------------------------
// Variant sync: this template renders the legacy Prestige form (no
// <variant-picker>), so nothing updates the hidden id select or fires
// variant:change when an option radio changes. Do it here, so the cart
// gets the right variant and the price/title/service-description
// listeners in product-template-mua.liquid run. Kept outside the gallery
// IIFE above, which returns early when there are no images.
// ---------------------------------------------------------------------
(function () {
  var productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return;

  var idSelect = productSection.querySelector("select[name='id']");
  var jsonEl = productSection.querySelector("[data-product-json]");
  if (!idSelect || !jsonEl) return;

  var variants;
  try {
    variants = JSON.parse(jsonEl.innerHTML).product.variants || [];
  } catch (e) {
    return;
  }

  function getSelectedOptions() {
    var selected = {};
    productSection
      .querySelectorAll("[data-option-position][type='radio']:checked, select[data-option-position]")
      .forEach(function (input) {
        selected[input.getAttribute("data-option-position")] = input.value;
      });
    return selected;
  }

  function findVariant(selected) {
    return variants.find(function (v) {
      if (selected["1"] !== undefined && v.option1 !== selected["1"]) return false;
      if (selected["2"] !== undefined && v.option2 !== selected["2"]) return false;
      if (selected["3"] !== undefined && v.option3 !== selected["3"]) return false;
      return true;
    }) || null;
  }

  productSection.addEventListener("change", function (e) {
    var input = e.target;
    if (!input.hasAttribute || !input.hasAttribute("data-option-position")) return;

    var variant = findVariant(getSelectedOptions());
    if (!variant) return;

    if (idSelect.value !== variant.id.toString()) {
      idSelect.value = variant.id;
      idSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    productSection.dispatchEvent(
      new CustomEvent("variant:change", { bubbles: true, detail: { variant: variant } })
    );
  });
})();
